import React from 'react';
import MarketingLayout from '../components/MarketingLayout';

const sections = [
    ['Information we collect', 'Restaurant profile details, menu data, order details, checkout fields, and account information needed to run the service.'],
    ['How information is used', 'Data is used to show menus, place orders, manage kitchen tickets, calculate analytics, and support restaurant operations.'],
    ['Customer order data', 'Customer names, phone numbers, table numbers, and instructions are collected only when enabled by the restaurant checkout settings.'],
    ['Storage and security', 'Application data is stored in Supabase with authentication and row-level security rules configured for restaurant ownership.'],
    ['Contact', 'For privacy questions, use the contact page and include the restaurant name connected to the request.'],
];

export default function PrivacyPage() {
    return (
        <MarketingLayout>
            <main className="mx-auto max-w-4xl px-4 py-16 lg:px-8">
                <p className="section-title">Privacy Policy</p>
                <h1 className="mt-3 text-5xl font-black tracking-tight">Privacy Policy</h1>
                <p className="mt-4 text-sm font-medium leading-6 text-slate-500">
                    This page describes the intended privacy approach for the GetYourQR QR ordering project.
                </p>
                <div className="mt-8 grid gap-4">
                    {sections.map(([title, text]) => (
                        <section key={title} className="card">
                            <h2 className="text-xl font-black">{title}</h2>
                            <p className="mt-2 text-sm font-medium leading-6 text-slate-500">{text}</p>
                        </section>
                    ))}
                </div>
            </main>
        </MarketingLayout>
    );
}
